import { render, staticRenderFns } from "./frontCarrosRecientes.vue?vue&type=template&id=19c658d0&"
import script from "./frontCarrosRecientes.vue?vue&type=script&lang=js&"
export * from "./frontCarrosRecientes.vue?vue&type=script&lang=js&"
import style0 from "./frontCarrosRecientes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports